// GC Nexon — Home page renders the Webflow theme HTML at "/" via WebflowPage.
import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function Home() {
  useSeo({
    title: "Sell Gift Cards for Cash Fast — PayPal, Zelle, Bitcoin | GC Nexon",
    description: "Get some of the highest payout rates available and same-day payouts. Check your rate before you submit, sell from 100+ brands via PayPal, Zelle, Cash App, Chime, or Bitcoin.",
    path: "/",
  });
  return (
    <WebflowPage
      htmlPath="/site/home-pages/home-v1.html"
      title="GC Nexon — Turn unused gift cards into cash"
    />
  );
}
